const Z_INDEX_SCALE = {
  SIZE_1: 0,
  SIZE_2: 10,
  SIZE_3: 20,
  SIZE_4: 30,
  SIZE_5: 40,
  SIZE_6: 50,
  SIZE_7: 60,
  SIZE_8: 70,
  SIZE_9: 80,
};

export default Z_INDEX_SCALE;
